/**
 * Navbar Comparamos - Mobile Menu & Accordion
 */

document.addEventListener('DOMContentLoaded', function() {
    // Mobile Menu Toggle
    const navbarToggle = document.querySelector('.navbar-toggle');
    const navbarMobileMenu = document.querySelector('.navbar-mobile-menu');

    if (navbarToggle && navbarMobileMenu) {
        navbarToggle.addEventListener('click', function() {
            this.classList.toggle('active');
            navbarMobileMenu.classList.toggle('active');
            
            // Deshabilitar/habilitar scroll del body
            if (navbarMobileMenu.classList.contains('active')) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        });
    }

    // Mobile Accordion
    const accordionItems = document.querySelectorAll('.navbar-mobile-accordion');

    accordionItems.forEach(item => {
        const btn = item.querySelector('.navbar-mobile-accordion-btn');
        const btnIcon = item.querySelector('.navbar-mobile-accordion-btn-icon');
        
        // Handle accordion button click
        if (btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                toggleAccordion(item);
            });
        }

        // Handle accordion icon button click (for Empresas)
        if (btnIcon) {
            btnIcon.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                toggleAccordion(item);
            });
        }
    });

    function toggleAccordion(item) {
        const isActive = item.classList.contains('active');
        
        // Close all accordions
        accordionItems.forEach(acc => {
            acc.classList.remove('active');
        });

        // Open clicked accordion if it wasn't active
        if (!isActive) {
            item.classList.add('active');
        }
    }

    // Close mobile menu when clicking outside
    document.addEventListener('click', function(e) {
        if (navbarToggle && navbarMobileMenu) {
            if (!e.target.closest('.navbar-comparamos')) {
                navbarToggle.classList.remove('active');
                navbarMobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
        }
    });

    // Close mobile menu on window resize to desktop
    window.addEventListener('resize', function() {
        if (window.innerWidth > 968) {
            if (navbarToggle && navbarMobileMenu) {
                navbarToggle.classList.remove('active');
                navbarMobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
            
            // Close all accordions
            accordionItems.forEach(acc => {
                acc.classList.remove('active');
            });
        }
    });
});
